import React from "react";
import styles from "./AccreditationsDescription.module.css";

interface AccreditationsDescriptionProps {
  data: string;
}

const AccreditationsDescription: React.FC<AccreditationsDescriptionProps> = (
  data
) => {
  return (
    <>
      <div className={"container"}>
        <div
          className={styles.pageDescription}
          dangerouslySetInnerHTML={{ __html: data?.data }}
        ></div>
      </div>
    </>
  );
};

export default AccreditationsDescription;
